import CityBalanceSummary from './CityBalanceSummary';
import { TaxCalculations } from "../../../model/tax_calculations";
import FormLayoutBalanceDue from "./FormLayoutBalanceDue";
import Box from "@mui/material/Box";
import CustomButton from "../../../components/CustomButton";
import { goBack, push } from "redux-first-history";
import { useDispatch } from "react-redux";

const NoBalance = ({ taxBreakdown, taxBalance }: { taxBreakdown: TaxCalculations, taxBalance: number }) => {
  const dispatch = useDispatch();

  return (
    <FormLayoutBalanceDue finalBalance={taxBalance} className="" isRefund={taxBreakdown.tax_liability - taxBreakdown.total_credits < 0}>
      <Box className='card'>
        <CityBalanceSummary taxBreakdown={taxBreakdown} />
      </Box>
      <span>
        The city does not collect balances of $10 or less or issue refunds on overpayments of $10 or less. 
        Click "Next" to electronically sign your return and finish filing.
      </span>
      <div className='btn-container'>
        <CustomButton
          variant="outlined"
          disableElevation={false}
          label={"back"}
          onClick={() => dispatch(goBack())}
          buttonSize='btn-lg'
        />
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          onClick={() => dispatch(push('/balance/sign')) }
          buttonSize="btn-lg"
        />
      </div>
    </FormLayoutBalanceDue>
  );
}

export default NoBalance;
